module.exports = __webpack_public_path__ + "img/dock-door-clearance-no.11ea72c0.svg";